import { RouteItem } from '@eastcoal/router/types/route'

import {
  MEMBER_ENTERPRISE_DETAIL_PAGE_PATH,
  MEMBER_PERSON_DETAIL_ROUTE
} from './constants/path'
import {
  MEMBER_DETAIL_PAGE_UUID,
  MEMBER_MANAGE_ACTION_UUID
} from './constants/uuid'

export const memberDetailRoute: RouteItem = {
  title: '会员详情',
  uuid: MEMBER_DETAIL_PAGE_UUID,
  hideChildrenInMenu: true,
  hideInMenu: true,
  children: [
    {
      title: '个人会员',
      path: MEMBER_PERSON_DETAIL_ROUTE,
      Component: () => import('./Person/index')
    },
    {
      title: '企业会员',
      path: MEMBER_ENTERPRISE_DETAIL_PAGE_PATH,
      Component: () => import('./Enterprise/index')
    },
    {
      title: '管理会员',
      uuid: MEMBER_MANAGE_ACTION_UUID
    }
  ]
}
